import { FIGHTER, type FighterState, type MatchState } from "../sim";
import { koFlight } from "./sprites/animation";

/**
 * Тело нокаутированного в полёте (консультант 05.11.2026: «нокаут читается как „осел на корточки“… отлёт назад с
 * разворотом, тяжёлое падение»). Клип подброса сам кончается стоя, поэтому тело заваливается навзничь поворотом скелета
 * от стоп: к касанию пола оно лежит. Решающий нокаут ещё и делает полный оборот вокруг вертикали. На полу — 0: лёжа
 * держит клип, а поворот гаснет тем же весом, что смешивание клипов (render/stage3d.ts).
 */
export function koBody(state: MatchState, fighter: FighterState): { spin: number; tilt: number } {
  if (fighter.state !== FIGHTER.ko || (fighter.y >= 0 && fighter.vy >= 0)) return { spin: 0, tilt: 0 };
  const u = koFlight(fighter);
  const settle = u * u * (3 - 2 * u);
  const fast = 1 - (1 - u) * (1 - u);
  const spin = state.slowmoDone === 2 && u < 1 ? -fighter.facing * Math.PI * 2 * fast : 0;
  return { spin, tilt: (Math.PI / 2) * settle };
}
